import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import { ThemeProvider } from "@mui/material/styles";
import { CssBaseline, GlobalStyles } from "@mui/material";

// Contextos e Temas
import theme from "./theme";
import { AuthProvider, useAuth } from "./context/AuthContext";

// Componentes Globais
import Header from "./components/Header";
import Footer from "./components/Footer";
import Loading from "./components/Loading";
import ScrollToTop from "./components/ScrollToTop"; // 🆕 Novo componente

// Páginas Públicas
import Home from "./pages/Home";
import Produtos from "./pages/Produtos";
import PageProduto from "./pages/PageProduto";
import Carrinho from "./pages/Carrinho";
import Checkout from "./pages/Checkout";
import AuthPage from "./pages/AuthPage";
import Sobre from "./pages/Sobre";
import Contato from "./pages/Contato";


// Páginas do Usuário
import MinhaConta from "./pages/MinhaConta";
import MeusPedidos from "./pages/MeusPedidos";

// Páginas Institucionais (Sugestão de placeholders se ainda não existirem)
// import Faq from "./pages/Faq"; 
// import Politicas from "./pages/Politicas";

// Página de Erro
import NotFound from "./pages/NotFound"; // 🆕 Página 404

// Rotas Administrativas
import AdminRouter from "./admin/routes/AdminRouter";
import AgeGate from "./components/AgeGate";

// --- ESTILOS GLOBAIS (Custom Scrollbar) ---
const globalStyles = (
  <GlobalStyles
    styles={{
      "*::-webkit-scrollbar": {
        width: "8px",
      },
      "*::-webkit-scrollbar-track": {
        backgroundColor: "#f1f1f1",
      },
      "*::-webkit-scrollbar-thumb": {
        backgroundColor: "#c1c1c1",
        borderRadius: "4px",
      },
      "*::-webkit-scrollbar-thumb:hover": {
        backgroundColor: "#a8a8a8",
      },
    }}
  />
);

// ⚠️ LAYOUT COMUM (Header + Footer + Loader)
const LayoutWithLoader = () => {
  const location = useLocation();
  const [loading, setLoading] = useState(true);
  const { user } = useAuth();

  useEffect(() => {
    setLoading(true);
    const timeout = setTimeout(() => setLoading(false), 600);
    return () => clearTimeout(timeout);
  }, [location.pathname]);

  return (
    <>
      <Loading visible={loading} />

      <Header user={user} />


      <div style={{ minHeight: "calc(100vh - 300px)", display: "flex", flexDirection: "column" }}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/produtos" element={<Produtos />} />
          <Route path="/produto/:id" element={<PageProduto />} />

          <Route path="/carrinho" element={<Carrinho />} />
          <Route path="/checkout" element={<Checkout />} />
          <Route path="/minha-conta" element={<MinhaConta />} />
          <Route path="/meus-pedidos" element={<MeusPedidos />} />

          <Route path="/sobre" element={<Sobre />} />
          <Route path="/contato" element={<Contato />} />


          <Route path="*" element={<NotFound />} />
        </Routes>
      </div>

      <Footer />
    </>
  );
};

const LayoutAuth = () => {
  const { user } = useAuth();

  return (
    <div style={{ minHeight: "100vh", display: "flex", flexDirection: "column" }}>
      <Header user={user} />
      <div style={{ flex: 1, display: "flex", flexDirection: "column" }}>
        <AuthPage />
      </div>
      <Footer />
    </div>
  );
};

export default function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      {globalStyles}

      <AuthProvider>
        <Router>

          <AgeGate />

          <ScrollToTop />

          <Routes>
            {/* 1. Rotas Administrativas (Isoladas) */}
            <Route path="/admin/*" element={<AdminRouter />} />

            {/* 2. Rota de Autenticação */}
            <Route path="/auth" element={<LayoutAuth />} />

            {/* 3. Rotas Públicas/Cliente (Catch-all para o restante) */}
            <Route path="/*" element={<LayoutWithLoader />} />
          </Routes>
        </Router>
      </AuthProvider>
    </ThemeProvider>
  );
}